import React, { useContext, useState } from 'react'
import { textcss } from '../../common/CSS';
import DatePickerField from './fields/DatePickerField';
import DropdownField from './fields/DropdownField';
import { GoogleInput } from './fields/GoogleInput';
import { InputCheckBox } from './fields/InputCheckBox';
import { InputFiled } from './fields/InputFiled'
import { OtpField } from './fields/Otpfield';
import { TextArea } from './fields/TextArea';
import { FormContext } from './Form';

export function Input(props) {

    const formContext = useContext(FormContext);
    const { label, labelClass, required, type, name, placeholder, inputcln, options, customValidation, className, accept, otp, setlocation, setOtp, multiple, otperror, errorMessage, setplace_id, place_i, setFormSubmit } = props
    const { form, error, errors, handleFormChange, handleFormOnBlur, handleFileUpload, handleClearFileUpload } = formContext;

    const [uploadedFile, setUploadedDFile] = useState([]);

    const onChangeHandler = (event, errorMessage) => {
        handleFormChange(event, errorMessage)
    }

    const onChangeFileUpload = (event, errorMessage) => {
        handleFileUpload(event, errorMessage)
    }

    const onBlurHandler = (event, errorMessage) => {
        handleFormOnBlur(event, errorMessage, customValidation)
    }

    const handleClearFile = (file, name) => {
        let files = [];
        files = ([...form[name]]).filter((elem) => {
            return file.name !== elem.name
        })
        handleClearFileUpload(files, name);
        setUploadedDFile([...files])
    }


    const handleUploadUI = (uploadedFile) => {
        let message = '';
        const fileLength = uploadedFile.length;
        if (fileLength === 0) {
            message = 'No File Choosen'
        } else if (fileLength === 1) {
            message = uploadedFile[0].name
        }
        else message = `${fileLength} File`;

        return <p className={`overflow-hidden w-full truncate ${textcss?.inputText}`}>{message}</p>
    }

    const onlyAcceptNumbers = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    }

    switch (type) {
        case "email":
            return <InputFiled errors={errors} className={className} label={label} inputcln={inputcln} value={form[name]} required={required} type={type} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} onBlurHandler={onBlurHandler} errorMessage={errorMessage} />
        case "text":
            return <InputFiled errors={errors} className={className} label={label} inputcln={inputcln} value={form[name]} required={required} type={type} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} onBlurHandler={onBlurHandler} errorMessage={errorMessage} />
        case "checkBox":
            return <InputCheckBox errors={errors} className={className} label={label} inputcln={inputcln} value={form[name]} required={required} type={type} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} onBlurHandler={onBlurHandler} errorMessage={errorMessage} />
        case "textarea":
            return <TextArea errors={errors} className={className} label={label} inputcln={inputcln} value={form[name]} required={required} type={type} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} onBlurHandler={onBlurHandler} errorMessage={errorMessage} />
        case "googlesearch":
            return <GoogleInput place_i={place_i} setplace_id={setplace_id} options={options} errors={errors} setlocation={setlocation} className={className} label={label} inputcln={inputcln} form={form} value={form[name]} required={required} type={"text"} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} errorMessage={errorMessage} setFormSubmit={setFormSubmit} />
        case "number":
            return <InputFiled errors={errors} error={error} className={className} onKeyPress={onlyAcceptNumbers} label={label} value={form[name]} required={required} type={"text"} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} errorMessage={errorMessage} />
        case "otp":
            return <OtpField errors={otperror} name={name} className={className} otp={otp} setOtp={setOtp} required={required} type={"number"} placeholder={placeholder} onChangeHandler={onChangeHandler} />
        case "dropdown":
            return <DropdownField errors={errors} options={options} className={className} label={label} labelClass={labelClass} value={form[name]} required={required} form={form} type={"text"} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} />
        case "datepicker":
            return <DatePickerField errors={errors} label={label} value={form[name]} required={required} form={form} name={name} placeholder={placeholder} onChangeHandler={onChangeHandler} />
        case "upload":
            return <>
                <div className={`px-1 py-1 ${className} mt-6`}>
                    <label className='block  border-b-2 '>
                        <span className="text-17F text-blurgray" >{label} {required && <span className="text-blurgray">*</span>}
                        </span>
                        <div className='flex justify-between relative'>
                            <div className='w-full'>
                                <input type="file" accept={accept} name={name} onChange={(event) => { onChangeFileUpload(event); setUploadedDFile(event.target.files) }} multiple={multiple} placeholder={placeholder} className='hidden w-9/12' required={required} onBlurCapture={onBlurHandler} />
                                <div className="py-2 truncate overflow-hidden mr-8 w-9/12">
                                    {handleUploadUI(form[name], errorMessage)}
                                </div>
                            </div>
                            <span className="z-20 material-icons text-3xl absolute w-6 cursor-pointer bottom-1"
                                style={{ right: "28%", left: "90%" }}
                            >attach_file</span>
                        </div>
                    </label>
                    <div className="pt-1 text-scogobgsky gap-2 flex flex-wrap">
                        {form[name] && [...form[name]].map((elem) => {
                            return <div className="w-24 px-1 flex text-xs">
                                <p className={` w-20 truncate text-scogoOrange ${textcss?.inputText}`}>{elem.name}</p>
                                <span className="text-xs bg-white z-50 material-icons cursor-pointer bottom-1" onClick={() => handleClearFile(elem, name)}>clear</span>
                            </div>
                        })}
                    </div>
                    {errors[name] && <span className="text-scogoclosed 2xl:text-font12 text-font10 font-normal">{errors[name]}</span>}
                </div>
            </>
        default:
            return <div></div>
    }
}
